import { Box } from '@mui/material'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'

interface InactiveCellProps {
  densityStyles: DensityStyleTypes
  onClick: () => void
}

const InactiveCell: FC<InactiveCellProps> = ({ densityStyles, onClick }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
      onClick={onClick}
    >
      –
    </Box>
  )
}
export default InactiveCell
